
const Input = (props) => {
    return(
        <>
            <label className={`block mt-5 mb-1 text-sm sm:text-base last-of-type:inline-block last-of-type:text-xs ${props.type === 'checkbox' && 'mr-2'} ${!props.label && 'hidden'}`}>{props.label}</label>
            <input
                type={props.showPass ? 'text' : props.type}
                checked={props.checked}
                name={props.name}
                placeholder={props.placeholder}
                value={props.value}
                className={`${(props.name === 'name' || props.name === 'password' || props.name === 'code') && 'block input-styles hover:border-green-500'} 
                   ${props.name === 'code' ? 'w-[40%]' : (props.name === 'password' || props.name === 'name') ? 'w-full' : ''} focus:border-borderColor focus:shadow-focusShadow`}
                onChange={props.handleChange}
                required={props.type !== 'checkbox'} />
        </>
    )
}

export default Input